<template>
  <form @submit.prevent="saveContact()">
    <div v-if="!someoneEditing && !existing" class="btn-container">
      <button class="btn btn-primary float-end add" type="button" @click="beginEdit()"><font-awesome-icon icon="pen" />
        NEW </button>
    </div>
    <div v-else-if="existing || (this.editing && topOrBottom===currentTopOrBottom)">
      <h1 v-if="immutable" class="mb-2">{{ localContact.id }}</h1>
      <select v-else :disabled="!editing" v-model="localContact.relationType" class="col-12 fs-2 text-center mb-2">
        <option v-for="relation in relationships" :key="relation.id" :value="relation.id">{{ relation.value }}</option>
      </select>
      <div v-if="editing && licensed" class="row mb-2 gx-2">
        <div class="col-12 col-md-1 mb-2 mb-lg-0">
          <button :disabled="!enableFindButton" type="button" class="btn btn-primary" @click="queryContact"
          >{{ nurse ? "FIND A NURSE BY" : "LOOKUP BY"}}</button>
        </div>
        <div class="col-12 col-md-2 mb-2 mb-lg-0 form-floating">
          <input :disabled="!editing" type="text" class="form-control" :id="id('queryLicense')"
            v-model.trim="locals.query.license.license" placeholder="license" />
          <label :for="id('queryLicense')" class="profile_label">LICENSE</label>
        </div>
        <div class="col-12 col-md-1 form-floating">
          <select :disabled="!editing" class="form-control" :id="id('queryState')"
            v-model.number="locals.query.license.state">
            <option default value="0">Select one</option>
            <option v-for="state in states" :key="state.id" :value="state.id">{{ state.abbr }}</option>
          </select>
          <label :for="id('queryState')" class="profile_label">STATE</label>
        </div>
        <div class="col-12 col-md-1 offset-md-1 ">
          <div class="row h-100 ps-0 pe-0 gx-0">
            <div class="col h-100">
              <div class="d-flex h-100 justify-content-center">
                <h4 class="align-self-center">
                  OR
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3 mb-2 mb-lg-0 form-floating">
          <input :disabled="!editing" type="text" class="form-control" :id="id('queryFirst')"
            v-model.trim="locals.query.name.first" placeholder="first name" />
          <label :for="id('queryFirst')" class="profile_label">FIRST</label>
        </div>
        <div class="col-12 col-md-3 form-floating">
          <input :disabled="!editing" type="text" class="form-control" :id="id('queryLast')"
            v-model.trim="locals.query.name.last" placeholder="last name" />
          <label :for="id('queryLast')" class="profile_label">LAST</label>
        </div>
      </div>
      <div v-if="editing && licensed">ADD A NEW NURSE</div>
      <div v-if="searchResults && searchResults.length === 0">
        No results
      </div>
      <div :class="'row xyz overflow-auto ' + (searchResults ? 'vh-100' : 'h-0')">
        <div v-for="(result,resultIndex) in searchResults" :class="'xyz2 row mb-2 gx-2 h-auto ' + (result.chosen ? 'bg-primary text-white' : ((resultIndex%2)?'':'tint'  ))"
          :key="result.id + (result.chosen ? 'x' : 'y')" @click="clickResult(result)">
          <div class="col-12 col-md-2 h-auto">
            <span>{{ (result.firstName || '') + ' ' + (result.lastName || '') }}</span>
          </div>
          <div class="col-12 col-md-1  h-auto">
            <span>{{ result.primaryPhone || '' }}</span>
          </div>
          <div class="col-12 col-md-1  h-auto">
            <span>{{ result.secondaryPhone || '' }}</span>
          </div>
          <!-- <div class="col-12 col-md-1">
            <span>{{ result.state ? states.find(s => s.id === result.state).abbr : '' }}</span>
          </div> -->
          <div class="col-12 col-md-1  h-auto">
            <span>{{ gg(result) }}</span>
          </div>

        </div>
      </div>
      <hr v-if="editing && nurse"/>
      <div class="row mb-2 gx-2">
        <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
          <input :disabled="!editing" type="text" class="form-control" :id="id('firstName')"
            v-model="localContact.firstName" placeholder="FIRST NAME" />
          <label :for="id('firstName')" class="profile_label">FIRST NAME</label>
        </div>
        <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
          <input :disabled="!editing" type="text" class="form-control" :id="id('lastName')"
            v-model="localContact.lastName" placeholder="LAST NAME" />
          <label :for="id('lastName')" class="profile_label">LAST NAME</label>
        </div>
        <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
          <input :disabled="!editing" type="text" class="form-control" :id="id('primaryPhone')"
            v-model.trim="localContact.primaryPhone" placeholder="PRIMARY PHONE" />
          <label :for="id('primaryPhone')" class="profile_label">PRIMARY PHONE</label>
        </div>
        <div class="col-md-1 col-12 form-group form-floating mb-2 mb-lg-0">
          <select :disabled="!editing" v-model.number="localContact.primaryPhoneType" :id="id('primaryPhoneType')"
            class="col-12 form-select">
            <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">{{ phone.type }}</option>
          </select>
          <label :for="id('primaryPhoneType')" class="profile_label">PHONE TYPE</label>
        </div>
      </div>
      <div class="row mb-2 gx-2">
        <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
          <input :disabled="!editing" type="text" class="form-control" :id="id('address1')"
            v-model="localContact.address1" placeholder="ADDRESS 1" />
          <label :for="id('address1')" class="profile_label">ADDRESS 1</label>
        </div>
        <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
          <input :disabled="!editing" type="text" class="form-control" :id="id('address2')"
            v-model="localContact.address2" placeholder="ADDRESS 2" />
          <label :for="id('address2')" class="profile_label">ADDRESS 2</label>
        </div>
        <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
          <input :disabled="!editing" type="text" class="form-control" :id="id('secondaryPhone')"
            v-model.trim="localContact.secondaryPhone" placeholder="SECONDARY PHONE" />
          <label :for="id('secondaryPhone')" class="profile_label">SECONDARY PHONE</label>
        </div>
        <div class="col-md-1 col-12 form-group form-floating mb-2 mb-lg-0">
          <select :disabled="!editing" v-model="localContact.secondaryPhoneType" :id="id('secondaryPhoneType')"
            class="col-12 form-select">
            <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">{{ phone.type }}</option>
          </select>
          <label :for="id('secondaryPhoneType')" class="profile_label">PHONE TYPE</label>
        </div>
      </div>
      <div class="row mb-2 gx-2">
        <div class="col-md-4 col-12 form-group form-floating">
          <input :disabled="!editing" type="text" class="form-control" :id="id('email')" v-model.trim="localContact.email"
            placeholder="EMAIL ADDRESS" />
          <label :for="id('email')" class="profile_label">EMAIL ADDRESS</label>
        </div>
        <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
          <input :disabled="!editing" type="text" class="form-control" :id="id('city')" v-model.trim="localContact.city"
            placeholder="CITY" />
          <label :for="id('city')" class="profile_label">CITY</label>
        </div>
        <div class="col-md-1 col-12 form-group form-floating mb-2 mb-lg-0">
          <select :disabled="!editing" type="text" class="form-select" :id="id('state')"
            v-model.number="localContact.state" placeholder="STATE">
            <option v-for="state in states" :key="state.id" :value="state.id">{{ state.abbr }}</option>
          </select>
          <label :for="id('state')" class="profile_label">STATE</label>
        </div>
        <div class="col-md-1 col-12 form-group form-floating mb-2 mb-lg-0">
          <input :disabled="!editing" type="text" class="form-control" :id="id('zip')" v-model.trim="localContact.zip"
            placeholder="ZIP" />
          <label :for="id('zip')" class="profile_label">ZIP</label>
        </div>
        <div v-if="immutable" class="col-md-2 col-12 form-group form-floating">
          <select :disabled="!editing" :id="id('relation')" v-model.number="localContact.relationType"
            class="form-select">
            <option v-for="relation in relationships" :key="relation.id" :value="relation.id">{{ relation.value }}
            </option>
          </select>
          <label :for="id('relation')" class="profile_label">RELATION</label>
        </div>
      </div>
      <div v-if="licensed" class="row mb-2 gx-2">
        <div class="col-12 col-md-2 mb-2 mb-lg-0 form-floating">
          <input :disabled="!editing" type="text" class="form-control" :id="id('license')"
            v-model.trim="localContact.license" placeholder="license" />
          <label :for="id('license')" class="profile_label">LICENSE</label>
        </div>
        <div class="col-12 col-md-1 form-floating">
          <select :disabled="!editing" class="form-control" :id="id('licenseState')"
            v-model.number="localContact.licenseState">
            <option default value="0">Select one</option>
            <option v-for="state in states" :key="state.id" :value="state.id">{{ state.abbr }}</option>
          </select>
          <label :for="id('licenseState')" class="profile_label">STATE</label>
        </div>
      </div>
      <div v-if="editing && verifiable" class="row mb-2 gx-2">
        <div class="col-12 col-md-1 mb-2 mb-lg-0">
          <button :disabled="!enableVerifyButton" type="button" class="btn btn-primary" @click="verifyContact">VERIFY
            LICENSE</button>
        </div>
        <div class="col-12 col-md-2 mb-2 mb-lg-0 form-floating">
          <input :disabled="!editing" type="text" class="form-control" :id="id('verifyLicense')"
            v-model.trim="locals.verify.license" placeholder="license" />
          <label :for="id('verifyLicense')" class="profile_label">LICENSE</label>
        </div>
        <div class="col-12 col-md-1 form-floating">
          <select :disabled="!editing" class="form-select" :id="id('verifyState')" v-model.number="locals.verify.state">
            <option disabled value="0">Select one</option>
            <option v-for="state in states" :key="state.id" :value="state.id">{{ state.abbr }}</option>
          </select>
          <label :for="id('verifyState')" class="profile_label">STATE</label>
        </div>
        <div v-if="!existing && locals.verify.more" class="form-floating col-12 col-md-2 mb-2 form-floating">
          <input :disabled="!editing" type="text"
            :class="'form-control ' + (locals.verify.more ? 'border border-2 border-warning' : '')" :id="id('verifySsn')"
            v-model.trim="locals.verify.ssn" placeholder="ssn" />
          <label :for="id('verifySsn')" class="profile_label">SSN</label>
        </div>
        <div v-if="!existing && locals.verify.more" class="form-floating col-12 col-md-2 form-floating">
          <input :disabled="!editing" type="date"
            :class="'form-control ' + (locals.verify.more ? 'border border-2 border-warning' : '')" :id="id('verifyDob')"
            v-model.trim="locals.verify.dob" placeholder="dob" />
          <label :for="id('verifyDob')" class="profile_label">DOB</label>
        </div>
        <div v-if="!existing && locals.verify.more" class="align-self-center  col-md-4 col-12"><span
            class="p-2 bg-warning text-body">required</span></div>
      </div>
      <div class="row mb-2">
        <div class="m-2 col text-black bg-warning">{{ locals.verify.message }}</div>
      </div>
      <div class="row mb-2">
        <div class="m-2 col">{{ licenseStatusDescription }}</div>
      </div>
      <div :class="((someoneEditing && !editing) ? 'invisible' : 'visible')">
        <div v-if="existing" class="btn-container">
          <button v-if="!editing" type="button" @click="beginEdit()" class="btn btn-primary">
            <font-awesome-icon icon="pen" /> EDIT</button>
          <button v-if="editing" type="reset" @click="cancelEdit()" class="btn btn-primary ">
            <font-awesome-icon icon="pen" /> CANCEL</button>
          <button v-if="dirty" type="submit" class="btn btn-primary">
            <font-awesome-icon icon="check" /> SAVE</button>
          <button v-if="!immutable && editing" class="btn btn-primary float-end" type="button"
            @click="deleteContact()">REMOVE FROM CURRENT CONTACTS</button>
        </div>
        <div v-else class="btn-container">
            <button v-if="dirty" type="submit" class="btn btn-primary" :disabled="verifiable && localContact.status !== 'UNENCUMBERED'">
            <font-awesome-icon icon="check" /> SAVE</button>
          <button v-if="editing" @click="cancelEdit()" class="btn btn-primary">
            <font-awesome-icon icon="pen" /> CANCEL</button>
        </div>
      </div>
      <div v-if="existing" class="btn-container">
        <button v-if="localContact.primaryContact" type="button" @click="prioritizeContact(false)"
          class="btn btn-primary float-end">
          <font-awesome-icon icon="ban" /> REMOVE PRIORITY</button>
        <button v-if="!localContact.primaryContact" type="button" @click="prioritizeContact(true)"
          class="btn btn-primary float-end">
          <font-awesome-icon icon="check" /> PRIORITIZE</button>
      </div>
    </div> <!-- endif -->
    <hr v-if="existing" />
  </form>
</template>

<script>
import { updateLicenseStatus, getLicenses, getContacts, createContact, updateContact, deleteContact, renameContact, setPrimaryContact } from "@/api/userApi";
import axios from 'axios';
import { CURR_API, OTHER_API } from "@/constants/apis";
import { uuid } from 'vue-uuid';
export default {
  name: 'user-contact',
  props: {
    contact: { type: Object, required: true },
    allData: { type: Object, required: true },
    existing: { type: Boolean, required: true },
    someoneEditing: { type: Boolean, required: true },
    emptyContact: { type: Object, required: true },
    allContacts: { type: Array, required: true },
    topOrBottom: { type: String, required: true },
    currentTopOrBottom: { type: String, required: true }
  },
  created() { this.revertContact(); },
  computed: {
    dirty: function () {
      if (!this.editing)
        return false;
      let that = this;
      let result = Object.keys(this.contact)
        .some(
          k =>
            that.contact[k] !== that.localContact[k]
        );
      return result;
    },
    ltype() {
      return this.isRelated(['Licensed Practical Nurse']) ? 'PN' : 'RN';
    },
    nurse() {
      return this.isRelated(['Licensed Practical Nurse', 'Registered Nurse']);
    },
    licenseStatusDescription: function () {
      if (this.localContact.status_time) {
        let status_time = typeof (this.localContact.status_time) === 'string' ?
          this.localContact.status_time :
          `(as of ${this.localContact.status_time.toLocaleString('en-US', { timeZone: 'America/New_York' })} EST)`;
        return this.localContact.status ?
          `${this.localContact.status} ${status_time}` :
          'Unverified'
      }
      else {
        return this.localContact.status || '';
      }
    },
    states: function () { return this.allData.states },
    phoneTypes: function () { return this.allData.phoneTypes },
    relationships: function () { return this.allData.relationDescriptions },
    immutable: function () {
      return false;
      /*
      return [
        'Emergency', 'Healthcare Proxy 1', 'Healthcare Proxy 2', 'Attorney',
        'maddress', 'paddress', 'personal', 'profile'].includes(this.localContact.id);
        */
    },
    verifiable: function () { 
      return this.isRelated([
        'Licensed Practical Nurse','Registered Nurse']);
    },
    licensed() {
      return this.isRelated([
        'Licensed Practical Nurse', 'Registered Nurse', 'Geriatric Care Manager',
        'Physical Therapist', 'Occupational Therapist', 'Dietician',
        'Social Worker', 'Speech Therapist']);
    },
    enableVerifyButton() {
      let verify = this.locals.verify;
      if (verify.license && verify.state)
        if (verify.more) {
          if (verify.dob && verify.ssn)
            return true;
          else
            return false;
        }
        else
          return true;
      return false;
    },
    enableFindButton() {
      if (this.editing) {
        let { name, license } = this.locals.query;
        if (name.first && name.last)
          return true;
        if (license.license && license.state)
          return true;
      }
      return false;
    }
  },
  data() {
    return {
      localContact: null,
      locals: this.emptyLocals(),
      editing: false,
      searchResults: null
    }
  },
  watch: {
    'locals.verify.state': {
      deep: false,
      handler() {
        this.locals.verify.more = false;
      }
    },
    'locals.verify.license': {
      deep: false,
      handler() {
        this.locals.verify.more = false;
      }
    },
    contact: {
      deep: true,
      handler(newValue) {
        this.localContact = this.dup(newValue);
      }
    },
    'locals.query.name': {
      deep: true,
      handler(name) {
        if (name.first || name.last) {
          this.locals.query.license.license = '';
          this.locals.query.license.state = 0;
        }
      }
    },
    'locals.query.license': {
      deep: true,
      handler(license) {
        if (license.license || license.state) {
          this.locals.query.name.first = '';
          this.locals.query.name.last = '';
        }
      }
    }
  },
  methods: {
    gg(result) {
      console.log(result);
      let st = result.state;
      console.log(st);
      if (st) {
        let x = this.states.find(s => {
          console.log(s);
          return s.id === st;
        });
        console.log(x);
        if(x && x.abbr)
          return x.abbr;
        else
          return '';
      }
      else
        return '';
    },
    dup: o => JSON.parse(JSON.stringify(o)),
    revertContact() { this.localContact = this.dup(this.contact) },
    send(eventName) { this.$emit(eventName, { contact: this.localContact, existing: this.existing, topOrBottom: this.topOrBottom }); },
    alertMessages(messages) { 
      if(Array.isArray(messages))
      {
        let newMessages = { ...messages };
        messages = newMessages;
      }
      alert([...new Set(Object.values(messages))].join("\n")); 
    },
    refreshContact() {
      let o = this.localContact;
      this.localContact = this.emptyContact;
      this.$nextTick(() => { this.localContact = o; })
    },
    beginEdit() {
      this.editing = true;
      this.searchResults = null;
      this.refreshContact();
      this.send('begin-edit');
    },
    cancelEdit() {
      this.$set(this.locals.verify,'message','');
      this.editing = false;
      this.revertContact();
      this.refreshContact();
      this.locals = this.emptyLocals();
      this.searchResults = null
      if(!this.existing) {
        this.$set(this.localContact,'status','');
        this.$set(this.localContact,'status_time',null);
      }
      this.send('cancel-edit');
    },
    deleteContact() {
      this.$set(this.locals.verify,'message','');
      this.editing = false;
      this.send('delete-contact');
      this.send('load-model');
    },
    prioritizeContact(value) {
      setPrimaryContact({
        id: this.localContact.id,
        primaryContact: value
      })
        .then(response => {
          if (response.length === undefined) {
            this.send('load-model');
          }
          else {
            this.alertMessages(response);
          }
        });
    },
    saveContact() {
      let process = f => {
        let temp = this.dup(this.localContact);
        if(temp.id === undefined || !temp.id)
          temp.id = uuid.v4();
        f(temp)
          .then(rawResponse => {
            let response;
            if(typeof(rawResponse) === 'object')
            {
              response = Object.values(rawResponse)
            }
            else
              response = rawResponse;
            if (response.length === undefined || !response.length) {
              this.editing = false;
              this.searchResults = null
              this.send('contact-saved');
              this.locals = this.emptyLocals();
              this.$set(this.locals.verify,'message','');
            }
            else {
              this.alertMessages(response);
            }
          })
          .catch(() => {
            alert('Error: Please contact website adminstrator')
          });
      };
      let localContact = this.localContact;
      if(this.licensed)
      {
        for(let k in this.allContacts)
        {
          if(this.allContacts[k].id === localContact.id)
            continue;
          if(this.allContacts[k].license === localContact.license &&
            this.allContacts[k].licenseState === localContact.licenseState &&
            localContact.license && localContact.licenseState)
          {
            alert('Duplicate licensed individual');
            return;
          }
        }
      }
      else
      {
        for(let k in this.allContacts)
        {
          if(this.allContacts[k].id === localContact.id)
            continue;
          if(this.allContacts[k].email === localContact.email && localContact.email)
          {
            alert('Duplicate email');
            return;
          }
        }
      }
      if(!this.licensed)
      {
        this.localContact.license = '';
        this.localContact.licenseState = 0;
        this.localContact.licenseId = undefined;
      }
      process(this.existing ? updateContact : createContact);
    },
    emptyLocals() {
      return this.dup({
        query: {
          name: { first: '', last: '' },
          license: { license: '', state: 0 }
        },
        verify: { license: '', state: 0, dob: null, ssn: '', message: '', more: false }
      });
    },
    isRelated(items) {
      if (this.localContact.relationType && items.length) {
        let f = this.relationships.find(r => r.id === this.localContact.relationType);
        return f && items.includes(f.value);
      }
      return false;
    },
    id(token) {
      return !this.existing ?
        `new-${token}` :
        `${this.contact.id}-${token}`
    },
    applyFoundContact(contact) {
      for(let j in this.allContacts)
      {
        if(this.allContacts[j].license === contact.license && this.allContacts[j].licenseState === contact.licenseState &&
          contact.license && contact.licenseState)
          {
            alert('Duplicate licensed individual');
            return false;
          } 
      }
      for (let k of Object.keys(this.emptyContact)) {
        if (['relationType','id'].includes(k))
          continue;
        else if(k === 'license') {
          this.locals.verify.license = contact[k] || '';
        }
        else if(k === 'licenseState') {
          this.locals.verify.state = contact[k] || 0;
        }
        else
          this.$set(this.localContact, k, contact[k] || this.emptyContact[k]);
      }
      this.refreshContact();
      return true;
    },
    queryContact() {
      let query = this.locals.query;
      let that = this;
      let localContact = this.localContact;
      for(let k in this.allContacts)
      {
        if(this.allContacts[k].id === localContact.id)
          continue;
        if(this.allContacts[k].license === query.license.license &&
          this.allContacts[k].licenseState === query.license.state &&
            localContact.license && localContact.licenseState)
          {
            alert('Duplicate licensed individual');
            return;
          }
      }
      getLicenses({
        ...query.name,
        ...query.license,
        ...query.state
      })
        .then(resp => {
          that.searchResults = resp;
        });
    },
    clickResult(result) {
      if(!this.applyFoundContact(result))
        return;
      for (let searchResultIndex = 0; searchResultIndex < this.searchResults.length; searchResultIndex++) {
        this.searchResults[searchResultIndex].chosen;
        if (this.searchResults[searchResultIndex].id === result.id)
          this.$set(this.searchResults[searchResultIndex], 'chosen', true);
        else
          this.$set(this.searchResults[searchResultIndex], 'chosen', false);
      }
    },
    verifyContact() {
      let verify = this.locals.verify;
      let localContact = this.localContact;
      for(let k in this.allContacts)
      {
        if(this.allContacts[k].id === localContact.id)
          continue;
        if(this.allContacts[k].license === verify.license &&
          this.allContacts[k].licenseState === verify.state)
          {
            alert('Duplicate registered nurse');
            return;
          }
      }

      verify.message = "Verifying with Nursys...";
      let abbr = this.states.find(state => verify.state === state.id).abbr;
      this.startLookup({
        jurisdiction: abbr,
        rnlicense: verify.license
      })
        .then((res) => {
          if (this.existing) {                   
            if(res.data && res.data.msg) {
              verify.message = 'License status cannot be verified at this moment. Please contact system administration';
              return;
            }
            let stateData = res.data.find(d =>  d.JurisdictionAbbreviation == abbr);
            let encumberStatus = stateData.LicenseStatus.toUpperCase();
            if (encumberStatus === 'UNENCUMBERED' || encumberStatus === 'ENCUMBERED' || encumberStatus === 'EXPIRED') {
              if(verify.license && verify.state)
              {
                this.$set(localContact,'license',verify.license);
                this.$set(localContact,'licenseState',verify.state)
//                this.saveContact();
                updateLicenseStatus({
                  state: verify.state,
                  license: verify.license,
                  status: encumberStatus,
                  contactId: localContact.id
                });
              }

              this.$set(this.localContact,'status_time',new Date());
              this.$set(this.localContact,'status',encumberStatus);
              verify.message = 'Verification request complete'
            }
            else {
              verify.message = 'License status cannot be verified at this moment. Please contact system administration';
            }
            return;
          }
          if (!res.data.status) {
              let stateData2 = res.data.find(d=> d.JurisdictionAbbreviation == abbr);
            if (!stateData2) {
              verify.message = 'Cannot verify the state of the provided license ID';
              return;
            }
            let encumberStatus2 = stateData2.LicenseStatus.toUpperCase();
            if (encumberStatus2 === 'UNENCUMBERED' || encumberStatus2 === 'ENCUMBERED' || encumberStatus2 === 'EXPIRED') {
              this.$set(localContact,'status',encumberStatus2);
              this.$set(localContact,'status_time',new Date());
              if(verify.license && verify.state)
              {
                this.$set(localContact,'license',verify.license);
                this.$set(localContact,'licenseState',verify.state)
              }
              verify.message = '';
            }
            else {
              alert('License status cannot be verified at this moment. Please contact system administration');
              localContact.status = '';
              localContact.status_time = new Date();
              this.verifyMessage = "License status cannot be verified at this moment. Please contact system administration";
            }
            return;
          }
          if (!verify.ssn || !verify.dob) {
            verify.more = true;
            verify.message = '';
            localContact.status = '';
            localContact.date = new Date();
            this.verifyMessage = "";
            return;
          }
          this.startAdd({
            jurisdiction: abbr,
            licensnum: verify.license,
            bdayear: verify.dob.substring(0, 4),
            lastfourssn: verify.ssn
          })
          .then((res) => {
            if (res.data.status === "Nurse Added") {
              this.$set(localContact,'status','UNENCUMBERED');
              this.$set(localContact,'status_time',new Date());
              verify.message = "";
              verify.more = false;

              this.send('load-model');
              if(verify.license && verify.state)
              {
                this.$nextTick(() => {
                  this.$set(localContact,'license',verify.license);
                  this.$set(localContact,'lienseState',verify.state)
                });
              }
             }
            else {
              verify.message = "Failed to verify nurse information. Please make sure all the requried fields are filled properly and try again.";
              localContact.status = '';
              localContact.status_time = new Date();
            }
          });
        });
    },
    async webHook(request) {
      return await axios.post(
        CURR_API + "/tswebhook.php",
//        "https://20.231.24.137/keyon/tswebhook.php",
        request,
        { headers: { 'Content-Type': 'application/json;' } });
    },
    async startLookup(request) {
      return this.webHook({
        NursyInfo: {
          API_Meth: "LookupNursesInfo", ncsid: "",
          ltype: this.ltype, ...request
        }
      });
    },
    async startAdd(request) {
      return this.webHook({ManageNurseList:{
        API_Meth: "Add_Nurse", ncsid: "", subactioncode: "A",
        ltype: this.ltype , address1: "Manhattan", address2: "",
        city: "New York", state: "NY", zip: "10001",
        hospitalpracsetting: "8", hostpracsettingother: "",
        notficationenabled: "N", reminderenabled: "N",
        locationlist: "", recid: "", ...request
      }});
    }
  }
}
</script>

<style scoped="true" lang="scss">
@import '~bootstrap/scss/bootstrap.scss';


$utilities: map-merge($utilities,
    ("width": map-merge(map-get($utilities, "width"),
        (values: map-merge(map-get(map-get($utilities, "width"), "values"),
            (10: 10%),
          ),
        ),
      ),
    ));

$utilities: map-merge($utilities,
    ("viewport-height": map-merge(map-get($utilities, "viewport-height"),
        (values: map-merge(map-get(map-get($utilities, "viewport-height"), "values"),
            (10: 10%,
              20: 20%,
              30: 30%,
              40: 40%),
          ),
        ),
      ),
    ));


.xyz {
  max-height: 10vh;
  transition: height 1s;
}
.tint {
  background-color: rgba(0,0,255,.05)
}
.xyz2:hover {
  background-color: rgba(0,0,255,.15)
}

$color-base: #0060ff;

.page {
  background-color: #fff;
  margin: 1.5rem auto;
  padding: 2.0rem;
  margin-bottom: 100px;
}

.profile__header {
  font-size: 1.5rem;
  color: $color-base;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1em;
}

.profile__label {
  font-size: 0.80rem;
  color: $color-base;
}

.profile__checkbox {
  font-size: 0.80rem;
  color: lighten(#000, 30%);
}

input,
select {
  font-size: 0.8rem;
}

.btn-container {
  margin-top: 1.0rem;

  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }

  padding-bottom: 3rem;
}

.new-cancel {
  background-color: red;
  border-color: red;
}

.cancel {
  visibility: hidden;
  background-color: red;
  border-color: red;
}

.submit {
  visibility: hidden;
}

.delete {
  visibility: hidden;
}

.favorite {
  color: red;
}

.unfavorite {
  color: $color-base;
}

.licenseInfo {
  display: flex;
  justify-content: center;
}

.statusInfo {
  color: $color-base;
  justify-content: center;
}

.button-container {
  display: flex;
  align-items: flex-end;
}

button[name="query_btn"]:enabled {
  background-color: $color-base;
  color: white;
}

button[name="validate_btn"]:enabled {
  background-color: $color-base;
  color: white;
}

// form.not-editing input {
//   disab
// }</style>
